module.exports = __webpack_public_path__ + "img/kalloveen_logo.77c9b577.png";